import { Box, Typography } from '@mui/material';
import { type ReactNode } from 'react';
import CustomButton from '@/components/CustomButton';
import { Clear } from '@/static';
import { type ModalContentProps } from '../../../state';
import styles from './styles';

type Props = {
  children: ReactNode;
  title: string;
  closeModal: ModalContentProps['closeModal'];
  onAccept?: () => void;
  acceptText?: string;
  acceptDisabled?: boolean;
  onCancel?: () => void;
  cancelText?: string;
};

const ModalLayout = ({
  children,
  title,
  closeModal,
  onAccept,
  acceptText = 'OK',
  acceptDisabled = false,
  onCancel,
  cancelText = 'Cancel',
}: Props) => (
  <Box>
    <Box sx={styles.header}>
      <CustomButton
        sx={styles.closeButton}
        endIcon={<Clear />}
        variant="text"
        onClick={closeModal}
      >
        Κλείσιμο
      </CustomButton>
    </Box>

    <Typography sx={styles.title} typography="h1">
      {title}
    </Typography>

    <Box sx={styles.body}>{children}</Box>

    {(onAccept || onCancel) && (
      <Box sx={styles.actions}>
        {onCancel && (
          <CustomButton onClick={onCancel} variant="outlined">
            {cancelText}
          </CustomButton>
        )}

        {onAccept && (
          <CustomButton
            onClick={onAccept}
            variant="contained"
            disabled={acceptDisabled}
          >
            {acceptText}
          </CustomButton>
        )}
      </Box>
    )}
  </Box>
);

export default ModalLayout;
